<style></style>

<template>
    <div class="text-danger" v-if="errors.length > 0">
        <ul class="list-unstyled">
            <li v-for="(msg, idx) in errors" :key="idx">{{ msg }}</li>
        </ul>
    </div>
</template>

<script>
    export default {
        props: {
            errors: {
                type: Array
            }
        }
    }
</script>